import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy: Writing and editing → Editor essentials. Started from the lesson
 * page in a new tab; never auto-started. The first step asks the officer to
 * open a report so it works with whatever is in their list.
 */
const tour: TutorialDefinition = {
  id: "editor-essentials",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Editor essentials",
  description: "The toolbar, the tabs, and the panel on the right.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "editor-essentials",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report",
      content: "Click any report to open it in the editor.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: sel("editorToolbar"),
      waitFor: sel("editorToolbar"),
      waitTimeoutMs: 10000,
      title: "The toolbar",
      content:
        "Styles, Bold, Italic, lists, Undo and Redo, plus Find and Replace, Writing suggestions, and Transcribe Audio for dictating at the cursor.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: sel("editorTabNarrative"),
      waitFor: sel("editorTabNarrative"),
      title: "Narrative and Transcription",
      content: "Switch between your report and the transcript here. A Footage tab appears when the case has analyzed video.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: sel("editorSidebarTabs"),
      waitFor: sel("editorSidebarTabs"),
      title: "The right panel",
      content: "Suggestions, Snippets, Statutes, and Redactions. A Checklist tab joins them when the case started from a checklist.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("editorNarrative"),
      waitFor: sel("editorNarrative"),
      title: "Select text, and save",
      content:
        "Select any text to open the floating menu with Enhance Writing, Redact, and Unredact. The editor saves as you type, but only while it has focus, so click into the narrative once after dictating or pasting from another window.",
      disableBeacon: true,
      placement: "right",
    },
  ],
};

export default tour;
